/**
 * Preferenza della voce per il testo-a-voce.
 *
 * La voce scelta sulla pagina di caricamento diventa il default della volta
 * dopo: è una preferenza permanente, non una proprietà del singolo episodio
 * (richiesta dell'utente, 2026-09-15 — "per impostare una voce di default,
 * basta ricordare l'ultima scelta").
 *
 * Sta in questo modulo, e non nel componente che la scrive, perché ora la
 * LEGGONO in due: la pagina di caricamento e il visore degli articoli. Con il
 * nome della chiave duplicato in entrambi, il giorno che cambiasse in uno solo
 * i due smetterebbero silenziosamente di parlarsi — e il sintomo sarebbe una
 * voce inattesa, difficile da ricondurre alla causa.
 */

const LAST_TTS_VOICE_KEY = "fyt-last-tts-voice";

/**
 * readRememberedVoice - L'ultima voce scelta, o "auto".
 * Tollera lo storage non disponibile (finestra privata, dati bloccati): in quel
 * caso non era stato memorizzato nulla comunque.
 */
export function readRememberedVoice() {
  try {
    return localStorage.getItem(LAST_TTS_VOICE_KEY) || "auto";
  } catch {
    return "auto";
  }
}

/** rememberVoice - Registra la voce scelta come default per la prossima volta. */
export function rememberVoice(voice) {
  try {
    localStorage.setItem(LAST_TTS_VOICE_KEY, voice || "auto");
  } catch {
    // Storage non disponibile: la scelta vale comunque per questo episodio.
  }
}

/**
 * voiceName - Nome leggibile da un id di voce: "grok:leo" → "Leo",
 * "it-IT-IsabellaMultilingualNeural" → "Isabella".
 *
 * Stava dentro EpisodeContextMenu (riga "Text to speech" della finestra
 * informazioni); spostato qui perché serve anche allo snackbar di /fides, e
 * due copie di questa regola divergerebbero al primo formato nuovo.
 *
 * @param {string} voice
 * @returns {string}
 */
export function voiceName(voice) {
  const v = String(voice || "");
  return v.startsWith("grok:")
    ? v.slice(5).replace(/^./, (c) => c.toUpperCase())
    : v.replace(/^[a-z]{2}-[A-Z]{2}-/, "").replace(/(Multilingual)?Neural$/, "");
}

/**
 * voiceLabel - Motore e nome: "Grok · Leo", "Edge · Isabella".
 * Il motore conta: Grok è a pagamento, Edge gratuito.
 *
 * @param {string} voice
 * @returns {string}
 */
export function voiceLabel(voice) {
  return `${String(voice || "").startsWith("grok:") ? "Grok" : "Edge"} · ${voiceName(voice)}`;
}
